import * as React from 'react';

import { ECpdLabelModalView } from 'shared/types/cpd/cpd';

import image1 from './assets/1.png';
import image2 from './assets/2.png';
import image3 from './assets/3.png';
import image4 from './assets/4.png';

export interface ICpdInfoCardItem {
  id: ECpdLabelModalView;
  imageUrl: string;
  imageStyle: React.CSSProperties;
  title: string;
  backgroundColor: '#E6F0FF' | '#F3F5FA';
  className?: string;
  isFirst?: boolean;
}

export const SOURCE_MAP: Record<ECpdLabelModalView, string> = {
  [ECpdLabelModalView.None]: '',
  [ECpdLabelModalView.Sdelka]: 'cpdCardDealObject',
  [ECpdLabelModalView.Profi]: 'cpdCardAgent',
  [ECpdLabelModalView.Documents]: 'cpdCardDocuments',
  [ECpdLabelModalView.RealFlat]: 'cpdCardRealObject',
};

export const CARDS_DATA: ICpdInfoCardItem[] = [
  {
    id: ECpdLabelModalView.Sdelka,
    title: 'Объект в Сделке',
    imageUrl: image1,
    backgroundColor: '#E6F0FF' as const,
    imageStyle: { width: '80px', height: '80px' },
    isFirst: true,
  },
  {
    id: ECpdLabelModalView.Profi,
    title: 'Надёжный эксперт',
    imageUrl: image2,
    backgroundColor: '#F3F5FA' as const,
    imageStyle: { width: '74px', height: '74px' },
  },
  {
    id: ECpdLabelModalView.Documents,
    title: 'Документы в порядке',
    imageUrl: image3,
    backgroundColor: '#F3F5FA' as const,
    imageStyle: { width: '74px', height: '87px' },
  },
  {
    id: ECpdLabelModalView.RealFlat,
    title: 'Жильё настоящее',
    imageUrl: image4,
    backgroundColor: '#F3F5FA' as const,
    imageStyle: { width: '79px', height: '79px' },
  },
];
